export const FALSE_POSITIVE_COMMENT = 'False positive';

export const isFalsePositiveComment = (value?: string | null) =>
  (value ?? '').trim().toLowerCase() === FALSE_POSITIVE_COMMENT.toLowerCase();
